import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
import createRouter from "./routes.js";
import mixin from "./mixin";
// import VueBus from 'vue-bus'
// Vue.use(VueBus)
import MetaInfo from "vue-meta-info";
// Vue.use(MetaInfo)
import bus from "./utils/bus";
Vue.prototype.$bus = bus;
import request from "./utils/request.js";
Vue.prototype.request = request;
import animated from "animate.css";
import "wowjs/css/libs/animate.css";
Vue.use(animated);
import vGoogleTranslate from "v-google-translate";
Vue.use(vGoogleTranslate);
// import FastClick from 'fastclick'
// FastClick.attach(document.body);
import scroll from "vue-seamless-scroll";
Vue.use(scroll);
Vue.use(ElementUI, { locale });
Vue.filter("format", function (d) {
  var date = new Date(d);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var min = date.getMinutes();
  min = min < 10 ? "0" + min : min;
  var s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  return y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
});

// FastClick.prototype.focus = function(targetElement) {
//  var length;
// // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
//  if (deviceIsIOS&& targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
//   length = targetElement.value.length;
//   targetElement.focus();
//   targetElement.setSelectionRange(length, length);
//  } else {
//   targetElement.focus();
// }
// };
Vue.config.productionTip = false;
// 注册翻译插件
// import translatePlugin from "./plugins/translate";
// Vue.use(translatePlugin);

// 初始化处理
async function initializeApp() {
  const router = await createRouter();
  router.beforeEach((to, from, next) => {
    if (to.meta.metaInfo) {
      store.commit("metaModule/CHANGE_META_INFO", to.meta.metaInfo);
    }
    next();
  });
  router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
  });

  Vue.mixin(mixin);
  new Vue({
    request,
    router,
    render: (h) => h(App),
  }).$mount("#app");
}

initializeApp();

// 初始化多语言切换
// Vue.prototype.$initTranslate();
